export enum BuyElectricityPurchaseType  {
	Exact = 1,
	Partial = 2,
	ReOrder = 3
} 

export interface BuyElectricityNavigationState {
	meterNumber: string;
	amountToPay?: string;
	paymentType: 'prepaid' | 'postpaid';
	purchaseType: BuyElectricityPurchaseType;
	billingDashNotificationId?: string;
}

export interface BuyElectricityFormData {
	meterNumber: string;
	amount: string;
}

export interface BuyElectricityConfirmationData {
	paymentType: PaymentType;
	meterNumber: string;
	amount: string;
	customerName: string;
	meterAddress?: string;
	phoneNumber?: string;
	outstandingBalance?: number;
	outstandingDebt?: number;
	disco: string;
	currency: string;
	fee?: number;
	showPreferRemoteTokenLoadOption?: boolean;
}

export type PaymentType = "prepaid" | "postpaid" | null;

export interface MeterValidationResponse {
	customerName: string;
	outstandingBalance?: number;
	currency?: string;
}

export interface BuyElectricityFormState {
	paymentType: "prepaid" | "postpaid" | null;
	meterNumber: string;
	amount: string;
	meterValidationData: MeterValidationResponse | null;
	showForm: boolean;
}

export type BuyElectricityViewState = "form" | "confirmation" | "payment" | "borrow-amount" | "borrow-confirmation" | "pin" | "processing" | "success"| "failed" | "ask-a-friend-form" | "ask-a-friend-sent";

export const VIEW_FLOW: Record<BuyElectricityViewState, { prev?: BuyElectricityViewState; next?: BuyElectricityViewState }> = {
	form: { next: "confirmation" },
	// Confirmation modal merges amount recap + payment-method selection (per Figma)
	confirmation: { prev: "form", next: "pin" },
	// "payment" view kept for any legacy entry points but unused in the merged flow
	payment: { prev: "confirmation", next: "pin" },
	"borrow-amount": { prev: "confirmation", next: undefined },
	"borrow-confirmation": { prev: "borrow-amount", next: undefined },
	pin: { prev: "confirmation", next: "processing" },
	processing: { prev: "confirmation", next: undefined },
	success: { prev: undefined, next: undefined },
	failed: { prev: undefined, next: undefined  },
	"ask-a-friend-form": { prev: "confirmation", next: undefined },
	"ask-a-friend-sent": { prev: undefined, next: undefined },
};

export enum PaymentOptions {
	"Card",
	"Wallet",
	"Mono",
	"Bank",
	"BorrowToken",
	"Cash",
	"Transfer",
	"AskAFriendToPay",
}

export interface BorrowEligibilityData {
	minimumBorrowAmount: number;
	maximumBorrowAmount: number;
	minimumVendAmount: number;
	outstandingDebt: number;
}

export interface BorrowConfirmationData {
	meterNumber: string;
	customerName: string;
	meterAddress?: string;
	disco: string;
	currency: string;
	borrowAmount: number;
}
